import { DocumentNode } from '@apollo/client'
import { CreateProjectFromQuoteDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'

export function useCreateProjectFromQuote(options?: {
  refetchQueries?: Array<string | DocumentNode>
}) {
  const [createProjectFromQuote] = useMutation(CreateProjectFromQuoteDocument, {
    extractorFn: (data) => data.financeMutations.convertToProjectFinanceQuote,
    ...(options?.refetchQueries ? { refetchQueries: options.refetchQueries } : {}),
  })

  return async (quoteId: number) => {
    const result = await createProjectFromQuote({
      variables: {
        id: quoteId,
      },
    })

    const handled = handleResult(result, handleResultWithFlash())
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.quotes.project_created_successfully'),
      })
    }
  }
}
